import { Route, Routes } from 'react-router-dom';

import { withAuthenticationRequired } from '@auth0/auth0-react';
import { ComponentType } from 'react';
import CustomLoader from '../components/common/CustomLoader';
import ExitPage from '../pages/ExitPage';
import UserHomePage from '../pages/HomePage';
import DesktopLayout from '../pages/Layout';
import LogsPage from '../pages/LogsPage';
import NotFound from '../pages/NotFound';

type ProtectedComponentProps = {
  component: ComponentType;
  authIsMock?: boolean;
};

const ProtectedComponent: React.FC<ProtectedComponentProps> = ({ component }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => <CustomLoader type="redirecting" />,
  });

  return <Component />;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<ProtectedComponent component={DesktopLayout} />}>
        <Route index element={<UserHomePage />} />
      </Route>
      <Route path="/logs" element={<ProtectedComponent component={DesktopLayout} />}>
        <Route index element={<LogsPage />} />
      </Route>
      <Route path="/exit" element={<ExitPage />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
